module.exports = __webpack_public_path__ + "static/product-9e68a435265414fce9d662364c4ccc4c.jpg";